class Agenda {
  agenda: HTMLElement | null;
  buttons: NodeListOf<HTMLButtonElement>;

  constructor() {
    this.agenda = document.querySelector('.agenda');
    this.buttons = this.agenda ? this.agenda.querySelectorAll('.agenda__btn')
      : ({} as NodeListOf<HTMLButtonElement>);

    if (this.agenda) {
      this.init();
    }
  }

  init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        this.toggle(btn);
      });
    });
  }

  toggle(btn: HTMLButtonElement) {
    const item = btn.closest('.agenda__item') as HTMLElement | null;
    if (!item) return;

    const description = item.querySelector('.agenda__description') as HTMLElement | null;
    if (!description) return;

    const isOpen = description.classList.contains('is-open');

    this.closeAll();

    if (!isOpen) {
      description.classList.add('is-open');
      description.style.maxHeight = description.scrollHeight + 'px';
    }
  }

  closeAll() {
    const descriptions = this.agenda!.querySelectorAll<HTMLElement>(
      '.agenda__description'
    );

    descriptions.forEach(desc => {
      desc.classList.remove('is-open');
      desc.style.maxHeight = '0';
    });
  }
}

export const agenda = new Agenda();
